// @flow
import PaymentOrders from './PaymentOrders';

export default PaymentOrders;
